module.exports = __webpack_public_path__ + "icofont.4abc402d95b5c1510848.woff";


//////////////////
// WEBPACK FOOTER
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/assets/icon/icofont/fonts/icofont.woff?v=1.0.0-beta
// module id = ../../../../../src/assets/icon/icofont/fonts/icofont.woff?v=1.0.0-beta
// module chunks = styles